import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=141ab110&scoped=true"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=141ab110&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ab110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141ab110')) {
      api.createRecord('141ab110', component.options)
    } else {
      api.reload('141ab110', component.options)
    }
    module.hot.accept("./AdminPanel.vue?vue&type=template&id=141ab110&scoped=true", function () {
      api.rerender('141ab110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AdminPanel.vue"
export default component.exports